<template lang="pug">  
    .col-12
      .carrier.card.shadow.mb-4
        .card-header.py-3
          h3.m-0.font-weight-bold.text-primary() Return Label
          i.closeForm.nav-item.fas.fa-fw.fa-times( v-on:click="closeModal()")          
        .card-body
          .col-12(v-if="!loading")
            iframe(:src="`/rp/server/return/label?returnId=${this.returnLabelInfo}`")
            //- vue-friendly-iframe(style="width:100%;height:500px;" :src="`/rp/server/return/label?returnId=${this.returnLabelInfo}`" )
          .col-12(v-else)
            Spinner
</template>

<script>

// import { mapState } from "vuex";
import convert from 'convert-units'
import moment from 'moment';
import Spinner from 'vue-simple-spinner'
export default {
  name: 'ReturnLabel',
  components:{
    Spinner
  },

  props: {    
    returnLabelInfo:String,
  },
  data:function(){
    return{
      loading:true,

    }
  },
  watch:{
      
  },
  computed:{
    
  },
  methods:{
    closeModal(){
      this.$emit('closeModal')
    }
  },
  async mounted(){
    this.loading = false;
    document.onkeydown = evt => {
      evt = evt || window.event;
      if (evt.keyCode == 27) {
        this.$emit("closeModal");
      }
    };
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  iframe{
    width:100%;
    height:900px;
  }
  .closeForm{
    position:absolute;
    right:20px;
    top:20px;
  }
</style>
